import React, { useEffect, useState } from 'react';
import api from '../services/api';
import './DynamicPostFeed.css';

const DynamicPostFeed = ({ section, isRightAligned }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const opacityValue = (section.background_opacity || 100) / 100;

  // Variáveis dinâmicas de alinhamento
  const alignClass = isRightAligned ? "section-header-right mb-5 pb-4" : "mb-5 pb-4";
  const revealDirection = isRightAligned ? "reveal-from-left" : "reveal-from-right";

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await api.get('/blog');
        setPosts(response.data);
      } catch (error) {
        console.error('Erro ao carregar o blog:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('pt-BR', { month: 'short' }).toUpperCase().replace('.', '');
    return { day, month };
  };

  const dynamicStyle = {
    position: 'relative',
    overflow: 'hidden' 
  };

  if (section.background_type === 'color' || (!section.background_image_url && section.background_color)) {
    dynamicStyle.backgroundColor = section.background_color;
  }

  return (
    <section 
      id={section.slug} 
      className={`py-5 ${(!section.background_color && !section.background_image_url) ? 'default-section' : ''}`} 
      style={dynamicStyle}
    >
      {/* CAMADA 0: Imagem com bg-parallax */}
      {section.background_type === 'image' && section.background_image_url && (
        <div className="bg-parallax" style={{ 
          position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', 
          backgroundImage: `url(${backendUrl}${section.background_image_url})`,
          backgroundSize: 'cover', backgroundPosition: 'center', zIndex: 0 
        }}></div>
      )}

      {/* CAMADA 1: Overlay */}
      {section.background_type === 'image' && section.background_image_url && (
        <div style={{ 
          position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', 
          backgroundColor: 'rgba(255, 255, 255, 0.99)', 
          opacity: opacityValue, zIndex: 1 
        }}></div>
      )}

      {/* CAMADA 2: Container de Conteúdo (Sempre com zIndex: 2) */}
      <div className="container py-5" style={{ position: 'relative', zIndex: 2 }}>

            {/* APENAS UMA DIV COM A CLASSE DINÂMICA */}
            <div className={alignClass}>
              <h2 className={`fonte-primaria display-4 section-title reveal-element ${revealDirection} duration-10`}>
                {section.title}
              </h2>
              <h4 className={`fonte-terciaria section-subtitle mb-4 reveal-element ${revealDirection} duration-12`}>
                {section.subtitle}
              </h4>
              
              {section.content && (
                <p className={`fonte-terciaria lead text-dark reveal-element ${revealDirection} duration-14`}>
                  {section.content}
                </p>
              )}
            </div>
            
            {loading ? (
            <div className="text-center">Carregando notícias...</div>
            ) : (
            <div className="row g-4">
                {posts.map(post => {
                const { day, month } = formatDate(post.date);
                return (
                    <div key={post.id} className="col-md-4">
                    <a href={post.link} target="_blank" rel="noopener noreferrer" className="text-decoration-none text-dark">
                        <div className="card h-100 border-0 shadow-sm blog-card">
                        
                        <div className="blog-image-wrapper">
                            <div className="blog-date-badge shadow" style={{ backgroundColor: 'var(--cor-primaria-5)' }}>
                            <span className="day" style={{ color: '#ffffff' }}>{day}</span>
                            <span className="month" style={{ color: 'var(--cor-primaria-1)' }}>{month}</span>
                            </div>
                            <img src={post.imageUrl || 'https://via.placeholder.com/400x250?text=Sem+Imagem'} className="card-img-top blog-img" alt={post.title} />
                            <div className="wave-divider"></div>
                        </div>

                        <div className="fonte-terciaria card-body p-4 text-center">
                            <h5 className="card-title fw-bold mb-3" style={{ color: 'var(--cor-primaria-4)' }}>
                            {post.title}
                            </h5>
                            <p className="card-text text-muted small">{post.excerpt}</p>
                        </div>
                        
                        </div>
                    </a>
                    </div>
                );
                })}
            </div>
            )}
        </div>
    </section>
  );
};

export default DynamicPostFeed;